import { Button, Col, DatePicker, Input, Row, Select, Space } from "antd";
import dayjs from 'dayjs';
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { SearchSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
const { RangePicker } = DatePicker;

// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    performSearchHandler,
    searchValue,
    title,
    setSearch,
    allUsers,
    setSelectedUser,
    selectedUser,
    selectedDate,
    setSelectedDate,
    totalRecords,
    medicineQcCount,
    qcTitle
  } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data
  );

  const isGroceryQualityCheckViewAll = checkPermission(userPermissions?.permissions, {
    permissionName: 'GroceryQualityCheck',
    permission: ['viewAll'],
  });

  const canViewAllUsers = userPermissions?.isAdmin || isGroceryQualityCheckViewAll;

  const activeUserOptions = useMemo(
    () =>
      (allUsers || [])
        .filter((item: any) => item?.status !== false)
        .map((item: any) => ({
          label: item?.name,
          value: item?.userId,
        })),
    [allUsers]
  );

  const inactiveUserOptions = useMemo(
    () =>
      (allUsers || [])
        .filter((item: any) => item?.status === false)
        .map((item: any) => ({
          label: item?.name,
          value: item?.userId,
        })),
    [allUsers]
  );
 
  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>
              {title}
              <span className={styles["search-filter__wrapper--title--count"]}>({totalRecords})</span>
            </div>
          </Col>
          <Col>
            <Space>
              {(!userPermissions?.isAdmin) &&
                <div className={styles["search-filter__wrapper--sub-title"]}>
                  {qcTitle}
                  <span className={styles["search-filter__wrapper--title--count"]}>({medicineQcCount})</span>
                </div>
              }
              <Button
                onClick={() => {
                  setSearch('');
                  if (canViewAllUsers) {
                    setSelectedUser(undefined);
                  }
                  setSelectedDate(null);
                }}
              >
                Clear all
              </Button>


              <Input
                className={styles["search-filter__search"]}
                placeholder="Search by Product Name"
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                allowClear
              />

              {canViewAllUsers &&
                <Select
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={selectedUser}
                  placeholder="Select User"
                  size="large"
                  style={{ width: 200 }}
                  onChange={(value) => setSelectedUser(value)}
                  allowClear
                  options={
                    [
                      ...(activeUserOptions.length
                        ? [{ label: 'Active', options: activeUserOptions }]
                        : []),
                      ...(inactiveUserOptions.length
                        ? [{ label: 'Inactive', options: inactiveUserOptions }]
                        : []),
                    ]
                  }
                />
              }

              <RangePicker
                picker="date"
                format="DD/MM/YYYY"
                style={{ width: 120, height: 40 }}
                allowClear
                onChange={(value) => {
                  if (!value || !value[0] || !value[1]) {
                    setSelectedDate(null);
                  } else {
                    setSelectedDate([
                      dayjs(value[0]).startOf("day"),
                      dayjs(value[1]).endOf("day")
                    ]);
                  }
                }}
                value={selectedDate}
              />
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;

